import localScaleManager from "../../../../../helpers/LocalScaleManager";
// import { Timer } from "../../seatTimer";
import { Parser } from "../../../../../helpers/parser";
import { WebSocketManager } from "../../../../../helpers/webSocketManager";

export class SeatBox extends Phaser.GameObjects.Image {
  /**
   * @param scene {GameScene}
   * @param username {string}
   * @param table {Table}
   */
  constructor(scene, username, table) {
    super(scene, 0, 0, scene.atlasTexture, "box");
    this.scene = scene;
    this.table = table;
    this.isMyTable = false;
    this.scene.add.existing(this);
    this.table.poolArray.push(this);
    this.setOrigin(0.5);
    // this.preFX.addBlur(1);
    this.setAlpha(0.9);
    this.playerInfo = null;
    this.activeSeatBox = null;
    this.boxShadow = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "seat-shadow")
      .setVisible(false);
    this.isActive = true;
    this.deactivate();
    this.table.poolArray.push(this.boxShadow);

    this.username = username;
    this.usernameTxt = this.scene.add.bitmapText(
      0,
      0,
      "HelveticaNeue",
      this.username
    );
    this.usernameTxt.setData("width", this.usernameTxt.width);
    this.usernameTxt.setData("height", this.usernameTxt.height);
    this.table.poolArray.push(this.usernameTxt);

    this.balance = "0";
    this.balanceTxt = this.scene.add.bitmapText(
      0,
      0,
      "HelveticaNeueTeal",
      this.balance
    );
    this.table.poolArray.push(this.balanceTxt);

    this.balanceTxt.setData("width", this.balanceTxt.width);
    this.balanceTxt.setData("height", this.balanceTxt.height);
    // this.timer = new Timer(scene, this.table);
    // this.timer = this.table.turnTimer;
    // this.activateTween = null;
    this.activateTweenDuration = 400;
    this.timeActionWarning = false;
    this.timeBankBtn = {};
    this.timeBankTimeOut = null;
    // this.setTint(0xff0000);
    // this.disabledBox = this.scene.add
    //   .image(0, 0, this.scene.atlasTexture, "disable-box")
    //   .setOrigin(0);
    // this.disabledBox
    //   .setDepth(this.depth + 10)
    //   .setAlpha(0.5)
    //   .setVisible(false);
    // this.table.poolArray.push(this.disabledBox);
    this.balanceCounter = null;
  }
  activate(playerInfo) {
    if (this.isActive) this.deactivate();
    this.isActive = true;
    const time = playerInfo.timeRemaining,
      timeBank = playerInfo.timeBank;
    let totalTime = 0;

    if (!playerInfo.online && playerInfo.disconnectTimeUsed) {
      totalTime = playerInfo.disconnectTime * 1000;
    } else if (playerInfo.useTimeBank) {
      totalTime = playerInfo.totalTimeBank * 1000;
    } else {
      totalTime = this.table.tableInfo.turnTime * 1000;
    }
    this.table.turnTimer.startTimer(
      time,
      totalTime,
      this,
      playerInfo.id || playerInfo.playerId
    );
    this.timeBankBtn = this.table.buttonManager.timeBankBtn;

    const oneThirdTotalTime = totalTime / 3;
    if (time <= oneThirdTotalTime) {
      /* remaining time is less than 1/3 total time  */
      this.activateTweenDuration = 200;
      if (this.isMyTable && playerInfo.online) {
        if (
          timeBank > 0 &&
          !playerInfo.useTimeBank &&
          !this.table.gameState.reDealing
        ) {
          this.timeBankBtn.show(playerInfo);
        }
        if (
          this.scene.audioEnable &&
          WebSocketManager.socket &&
          WebSocketManager.socket.connected
        ) {
          this.table.sounds.play("timer");
        }
      }
    } else {
      this.activateTweenDuration = 400;
      /*remaining time is more than 1/3 total time */
      this.timeBankTimeOut = this.scene.time.addEvent({
        delay: time - oneThirdTotalTime, // ms
        callback: () => {
          if (!this.scene) return;
          /*remaining time got less than 1/3 total time */
          this.activateTweenDuration = 400;
          if (this.isMyTable && playerInfo.online) {
            if (
              timeBank > 0 &&
              !playerInfo.useTimeBank &&
              !this.table.gameState.reDealing
            ) {
              this.timeBankBtn.show(playerInfo);
            }
            if (
              this.scene.audioEnable &&
              WebSocketManager.socket &&
              WebSocketManager.socket.connected
            ) {
              this.table.sounds.play("timer");
            }
          }
          // if (this.activateTween) this.scene.tweens.remove(this.activateTween);
          // if (!this.activeSeatBox.visible) this.activeSeatBox.setVisible(true);
          this.table.seatTurnGlow.show(this, this.activateTweenDuration);
          // this.activeSeatBox.setScale(this.activeSeatBoxInitScale);
          // this.activateTween = this.scene.add.tween({
          //   targets: this.activeSeatBox,
          //   duration: this.activateTweenDuration,
          //   ease: "Linear",
          //   // scale: "*= 0.85",
          //   // scale: "*= 0.95",
          //   scale: "*= 0.9",
          //   yoyo: true,
          //   repeat: -1,
          // });
        },
        //args: [],
        callbackScope: this,
        loop: false,
      });

      // this.timeBankTimeOut = setTimeout(()=>{
      //   // console.log("remaining time got less than 1/3 total time ");
      //   this.activateTweenDuration = 1000;
      //   if (this.isMyTable && playerInfo.online){
      //   if (timeBank > 0 && !playerInfo.useTimeBank && !this.table.gameState.reDealing) {
      //     this.timeBankBtn.show();
      //   }
      //   if (this.scene.audioEnable && WebSocketManager.socket && WebSocketManager.socket.connected){
      //     this.table.sounds.play("timer");
      //   }
      // }
      //   if (this.activateTween) this.scene.tweens.remove(this.activateTween);
      //   this.activeSeatBox.setVisible(true);
      //   this.activeSeatBox.setScale(this.activeSeatBoxInitScale);
      //   this.activateTween = this.scene.add.tween({
      //     targets: this.activeSeatBox,
      //     duration: this.activateTweenDuration,
      //     ease: "Linear",
      //     // scale: "*= 0.85",
      //     // scale: "*= 0.95",
      //     scale: "*= 0.9",
      //     yoyo: true,
      //     repeat: -1,
      //     onStart: () => {
      //       console.warn("activate tween set timeout");
      //     },
      //   })
      // }, time - oneThirdTotalTime)
      // console.log("timeout: " + (time - oneThirdTotalTime));
    }
    this.table.seatTurnGlow.show(this, this.activateTweenDuration);

    // if (this.activateTween) this.activateTween.destroy();
    // if (!this.activeSeatBox.visible) this.activeSeatBox.setVisible(true);
    // this.activeSeatBox.setScale(this.activeSeatBoxInitScale);
    // this.activeSeatBox.setAlpha(1);
    // this.activateTween = this.scene.add.tween({
    //   targets: this.activeSeatBox,
    //   duration: 400,
    //   ease: "Linear",
    //   // scale: "*= 0.85",
    //   // scale: "*= 0.95",
    //   // scale: "*= 0.1",
    //   alpha: 0,
    //   yoyo: true,
    //   loopDelay: 200,
    //   loop: -1,
    //   // onStart: () => {
    //   //   console.warn("activate tween");
    //   // },
    // });
  }
  resetAlpha() {
    this.setAlpha(0.9);
  }
  deactivate() {
    if (!this.isActive) return;
    this.table.seatTurnGlow.hide();
    // console.warn("deactivate" + this.username);
    // if (this.activeSeatBox.visible) this.activeSeatBox.setVisible(false);
    // if (this.frame.name !== "box") this.setFrame("box").setOrigin(0);

    // this.activeSeatBox.setScale(this.activeSeatBoxInitScale);
    // if (this.timer) this.timer.stopTimer();
    this.isActive = false;
    // if (this.activateTween) this.activateTween.destroy();
    if (this.isMyTable && this.timeBankBtn && this.timeBankBtn.isShowing) {
      this.timeBankBtn.hide();
    }
    if (this.timeBankTimeOut) {
      this.timeBankTimeOut.remove();
      this.scene.time.removeEvent(this.timeBankTimeOut);
      this.timeBankTimeOut = null;
    }
    // clearTimeout(this.timeBankTimeOut);
  }
  updatePlayerInfo(playerInfo, state) {
    const preTxt = this.balance;
    this.playerInfo = playerInfo;
    // this.balance = Parser.toCurrency(playerInfo.balance);
    if (playerInfo.joinMode === "Reserved") {
      this.balance = Parser.convertToXLetters("Reserving", 11);
      this.balanceTxt.setText(this.balance);
      this.balanceTxt.setX(this.x - this.balanceTxt.width / 2);
    } else if (playerInfo.lastAction === "AllIn" && playerInfo.balance === 0) {
      // if(this.scene.audioEnable) this.scene.sound.play("allin");
      this.balance = Parser.convertToXLetters("All-in", 11);
      this.balanceTxt.setText(this.balance);
      this.balanceTxt.setX(this.x - this.balanceTxt.width / 2);

      // console.log(preTxt.trim() !== this.balance.trim());
      if (preTxt.trim() !== this.balance.trim()) {
        /* bar aval k allin shode*/
        this.table.sounds.play("allin");
      }
    } else {
      this.balance = Parser.convertToXLetters(
        playerInfo.balance.toLocaleString(),
        11
      );
      if (state !== "End" && state != "PreEnd") this.updateBalance();
    }
    this.username = Parser.convertToXLetters(playerInfo.username, 9);
    this.usernameTxt.setText(this.username);
    this.usernameTxt.setX(this.x - this.usernameTxt.width / 2);
    // if(this.isMyTable){
    //   if(this.frame.name !== "self-player-box") {
    //     this.setFrame("self-player-box");
    //   }
    // }
    // else if(this.frame.name !== "box") {
    //   this.setFrame("box", false, false);
    // }
  }
  updateBalance(useCounter, win, balance) {
    if(this.balanceCounter && this.balanceCounter.isSeeking) return
    if(!useCounter){
      this.balanceTxt.setText(this.balance);
      this.balanceTxt.setX(this.x - this.balanceTxt.width / 2);
    }
    else {
      this.balanceCounter = this.scene.tweens.addCounter({
        from: balance - (win ? win : 0),
        to: balance,
        duration: 2000,
        ease: 'linear',
        onUpdate: tween =>
        {
          const text = Parser.convertToXLetters(
            Math.round(tween.getValue()).toLocaleString(),
            11
          );
          this.balanceTxt.setText(text);
          this.balanceTxt.setX(this.x - this.balanceTxt.width / 2);
        },
    });
    }
  }
  setDisable(status) {
    if (status) {
      // if (this.frame.name !== "disable-box") {
      //   this.setFrame("disable-box", false, false);
      // }
      // if (this.usernameTxt.font !== "HelveticaNeueGray") {
      //   this.usernameTxt.setFont("HelveticaNeueGray");
      // }
      // if (this.balanceTxt.font !== "HelveticaNeueGray") {
      //   this.balanceTxt.setFont("HelveticaNeueGray");
      // }
    } else {
      // if (this.frame.name !== "box") {
      //   this.setFrame("box", false, false);
      // }
      // if (this.usernameTxt.font !== "HelveticaNeue") {
      //   this.usernameTxt.setFont("HelveticaNeue");
      // }
      // if (this.balanceTxt.font !== "HelveticaNeueTeal") {
      //   this.balanceTxt.setFont("HelveticaNeueTeal");
      // }
    }
  }
  visibilityControls(visibility) {
    if (this.visible !== visibility) this.setVisible(visibility);
    if (this.usernameTxt.visible !== visibility)
      this.usernameTxt.setVisible(visibility);
    if (this.balanceTxt.visible !== visibility)
      this.balanceTxt.setVisible(visibility);

    if (this.isMyTable) {
      if (this.boxShadow.visible) {
        this.boxShadow.setVisible(false);
      }
    } else if (this.boxShadow.visible !== visibility) {
      this.boxShadow.setVisible(visibility);
    }
  }
  /***
   *
   * @param width {number} width of table
   * @param height {number} width of table
   * @param initX {number} table top left x
   * @param initY {number} table top left y
   * @param isMyTable {boolean}
   */
  positionControls(width, height, initX, initY, isMyTable) {
    this.isMyTable = isMyTable;
    // const activeBoxSize = isMyTable ? width / 2.8 : width / 4.7;
    // const activeBoxSize = isMyTable ? this.displayWidth * 1.5 : this.displayWidth * 2;
    // const activeBoxSize = this.displayWidth * 2;
    // localScaleManager.scaleSprite(
    //   this.activeSeatBox,
    //   activeBoxSize,
    //   activeBoxSize,
    //   0,
    //   1,
    //   true
    // );
    localScaleManager.scaleSprite(
      this.boxShadow,
      this.displayWidth * 1.5,
      this.displayWidth * 1.5,
      0,
      1,
      true
    );
    // localScaleManager.scaleSpriteTo(this.activeSeatBox, activeBoxScale);
    // this.activeSeatBox.setPosition(this.x - (this.activeSeatBox.displayWidth - this.displayWidth) / 2, this.y - (this.activeSeatBox.displayHeight - this.displayHeight) / 2);
    this.boxShadow.setPosition(this.x, this.y + this.displayHeight / 2);
    // this.activeSeatBox.setPosition(
    //   this.x,
    //   this.y - this.displayHeight * .8
    // );
    // this.activeSeatBoxInitScale = this.activeSeatBox.scale;
    // this.activeSeatBox.setData("initScale", this.activeSeatBox.scale);

    this.textSize = this.displayWidth;
    localScaleManager.scaleBitMapText(
      this.usernameTxt,
      this.textSize,
      this.displayHeight * 0.3,
      0,
      1,
      false
    );
    this.usernameTxt.setPosition(
      //FIXME: TypeError: Cannot read properties of null (reading 'scaleX') /
      this.x - this.usernameTxt.width / 2,
      this.y - this.displayHeight * 0.45
      // this.y + (this.displayHeight / 2.5 - this.usernameTxt.height) / 2
    );

    this.balanceTextSize = isMyTable
      ? this.displayWidth / 1.5
      : this.displayWidth / 1.3;
    // const balanceTextSize = this.displayWidth / 1.5 ;
    localScaleManager.scaleBitMapText(
      this.balanceTxt,
      this.balanceTextSize,
      this.displayHeight * 0.3,
      0,
      1,
      false
    );
    this.balanceTxt.setPosition(
      this.x - this.balanceTxt.width / 2,
      this.y + this.displayHeight * 0.1
      // this.y + (3.75 * this.displayHeight) / 6 - this.balanceTxt.height / 2
    );

    // this.timer.positionControls(
    //   this.displayWidth,
    //   this.displayHeight,
    //   this.x,
    //   this.y
    // );
    // this.activate();
    // this.disabledBox.setPosition(this.x, this.y);
    // this.disabledBox.setScale(this.scale);
  }
  /***
   *
   * @param width {number} width of table
   * @param height {number} width of table
   * @param initX {number} table top left x
   * @param initY {number} table top left y
   * @param isMyTable {boolean}
   */
  reposition(width, height, initX, initY, isMyTable) {
    this.isMyTable = isMyTable;
    // this.activeSeatBox.setPosition(
    //   this.x + this.displayWidth / 2,
    //   this.y - this.displayHeight * .5
    // );
    this.usernameTxt.setPosition(
      this.x - this.usernameTxt.width / 2,
      this.y - this.displayHeight * 0.45
    );
    this.balanceTxt.setPosition(
      this.x - this.balanceTxt.width / 2,
      this.y + this.displayHeight * 0.1
    );
    this.boxShadow.setPosition(this.x, this.y + this.displayHeight / 2);
    // this.timer.reposition(
    //   this.displayWidth,
    //   this.displayHeight,
    //   this.x,
    //   this.y
    // );
  }

  remove() {
    // this.activeSeatBox.destroy();
    this.usernameTxt.destroy();
    this.balanceTxt.destroy();
    // this.timer.remove();
    this.destroy();
  }
}
